import { List } from 'immutable';
import { createSelector, defaultMemoize } from 'reselect';

import { isResourceLoading, isResourceFailed, getResourceError } from './common';

const isGuideLoading = defaultMemoize(isResourceLoading);
const isGuideFailed = defaultMemoize(isResourceFailed);
const getGuide = defaultMemoize((data) => data.get('guide'));
const getGuideError = defaultMemoize(getResourceError);

const getGuidesByStateData = (state) => state.getIn(['app', 'guidesByState']);
const isGuidesByStateLoading = createSelector(getGuidesByStateData, isResourceLoading);
const getGuidesByState = createSelector(getGuidesByStateData, (data) => data.get('guides', List()).toJS());
const getGuidesByStatePage = createSelector(getGuidesByStateData, (data) => data.get('page'));
const getGuidesByStateTotal = createSelector(getGuidesByStateData, (data) => data.get('total'));

export {
    getGuide,
    getGuideError,
    getGuidesByState,
    getGuidesByStateData,
    getGuidesByStatePage,
    getGuidesByStateTotal,
    isGuideLoading,
    isGuideFailed,
    isGuidesByStateLoading,
};
